import axios from 'axios'

const period = {}
// 统计分值
period.start = params => { return axios.get('/lawyer/score/stat', {params}) }
// 加载律师
// period.load = params => { return axios.get('/lawyer/load', {params}) }
// 记录学时
period.save = params => { return axios.post('/lawyer/score/save', params) }
// 查询记录
period.find = params => { return axios.get('/lawyer/score/find', {params}) }
// 学时详情
period.view = params => { return axios.get('/lawyer/score/view', {params}) }
// 添加学分时间点
period.addTimeNode = params => { return axios.post('/sys/timeNode/save', params) }
// 查询学分时间点
period.findTimeNode = params => { return axios.get('/sys/timeNode/find', {params}) }
// 查询观看历史记录
period.historicalRecord = params => { return axios.get('/lawyer/score/historicalRecord', {params}) }
export default period



// WEBPACK FOOTER //
// ./src/api/period.js